import type { IntlShape } from "react-intl";
import type InputType from "../../Input/InputType";
import { JsonInputType } from "../../Input/JsonInputType";
import type { SideName } from "../../Side/SideName";
import Plate from "../Plate";

export default abstract class Circle extends Plate {
	public getDimensionsString(input: InputType, intl: IntlShape): string | undefined {
		if (input.width !== undefined) {
			const { width } = this.formatInputs(input, intl);

			return `ø ${width}`;
		}
		return undefined;
	}

	public calculateSideLength(_side: SideName, input: InputType) {
		const diameter = Number(input[JsonInputType.Diameter]);

		if (!Number.isNaN(diameter)) {
			return diameter * Math.PI;
		}

		return undefined;
	}
}
